/* eslint-disable react/jsx-props-no-spreading */

/**
 * @deprecated This component is deprecated and will be removed in a future release.
 * Please use the new Quimby UI component instead:
 *
 * Import: `import { SelectInput } from '@ui/molecules/inputs';`
 * Or: `import { SelectInput } from '@ui/molecules/inputs/form';`
 *
 * Or specific path: `import { SelectInput } from '@ui/molecules/inputs/form/SelectInput';`
 *
 * See the new component for documentation and migration notes.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { translate } from '@utils/i18n';
import clsx from 'classnames';
import './Select.scss';

const namespace = 'features.commons';

const Select = React.forwardRef(
  (
    {
      id,
      options,
      onChange,
      onBlur,
      name,
      disabled,
      label,
      noOptionLabel = translate('select_an_option', { namespace }),
      required = false,
      multiple = false,
      value,
      error
    },
    ref
  ) => {
    const handleChange = (e) => {
      if (multiple) {
        const selectedValues = Array.from(e.target.selectedOptions, (option) => option.value);
        onChange(e, selectedValues);
      } else {
        onChange(e);
      }
    };

    return (
      <div className={clsx('qmb-select--x-full selectContainer', { 'has-error': error })}>
        <select
          id={id}
          name={name}
          ref={ref}
          onChange={handleChange}
          onBlur={onBlur}
          disabled={disabled}
          multiple={multiple}
          value={multiple ? undefined : value}
          size={multiple ? Math.min(options.length + 1, 5) : 1}>
          {!multiple && (
            <option value="" disabled={required}>
              {noOptionLabel}
            </option>
          )}
          {options.map((option) => (
            <option
              key={option.value}
              value={option.value}
              selected={multiple && Array.isArray(value) && value.includes(option.value)}>
              {option.label}
            </option>
          ))}
        </select>
        <label htmlFor={id} className={clsx('qmb-label', { '--required': required })}>
          {label}
        </label>
        {error && <span className="error-message">{error}</span>}
      </div>
    );
  }
);

Select.displayName = 'Select';

export default Select;

Select.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
  ).isRequired,
  id: PropTypes.string.isRequired,
  noOptionLabel: PropTypes.string,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.string,
  required: PropTypes.bool,
  multiple: PropTypes.bool,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]))
  ]),
  error: PropTypes.string
};

Select.defaultProps = {
  onChange: () => {},
  onBlur: () => {},
  noOptionLabel: translate('select_an_option', { namespace }),
  name: '',
  disabled: false,
  label: '',
  required: false,
  multiple: false,
  value: undefined,
  error: null
};
